import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cva } from "class-variance-authority";
import { Loader2 } from "lucide-react";
import * as React from "react";
import { cn } from "../lib/cn.js";
/**
 * docs/design.md §7.1. Sizing is deliberately fixed per variant rather
 * than left to ad hoc padding — `xl` (64px) exists only for Live Mode's
 * primary transport action (§10.6), never a general-purpose CTA size.
 */
const buttonVariants = cva([
    "inline-flex items-center justify-center gap-2 whitespace-nowrap",
    "rounded-md text-body font-medium transition-colors duration-fast",
    "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-primary focus-visible:ring-offset-2 focus-visible:ring-offset-canvas",
    "disabled:pointer-events-none disabled:opacity-40 disabled:text-fg-tertiary",
].join(" "), {
    variants: {
        variant: {
            primary: "bg-brand-primary text-white hover:bg-brand-primary/90 active:bg-brand-primary/80",
            secondary: "border border-line bg-transparent text-fg-primary hover:bg-surface-hover active:bg-surface-overlay",
            ghost: "bg-transparent text-fg-primary hover:bg-surface-hover active:bg-surface-overlay",
            danger: "bg-status-critical text-white hover:bg-status-critical/90 active:bg-status-critical/80",
            success: "bg-status-success text-white hover:bg-status-success/90 active:bg-status-success/80",
        },
        size: {
            sm: "h-7 px-2.5 text-caption",
            md: "h-9 px-3.5",
            lg: "h-11 px-5 text-h3",
            xl: "h-16 px-8 text-h2",
        },
    },
    defaultVariants: {
        variant: "primary",
        size: "md",
    },
});
export const Button = React.forwardRef(({ className, variant, size, loading, disabled, children, ...props }, ref) => {
    return (_jsxs("button", { ref: ref, className: cn(buttonVariants({ variant, size }), className), disabled: disabled || loading, "aria-disabled": disabled || loading, "aria-busy": loading || undefined, ...props, children: [loading ? _jsx(Loader2, { className: "size-4 animate-spin", "aria-hidden": "true" }) : null, children] }));
});
Button.displayName = "Button";
//# sourceMappingURL=button.js.map